module.exports = __webpack_public_path__ + "img/laboratory_06.83aae523.png";